import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/Contact';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequestLeader';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformationLeader';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { AdditionalConsentSubForm } from '../subforms/AdditionalConsent';

export const BBBankFachkraefteSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(ContactSchema(settings))
        .concat(SalaryRequestSchema)
        .concat(OtherInformationSchema)
        .concat(DocumentsSchema(settings))
);

export const BBBankFachkraefte = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalConsentSubForm} />
        </>
    );
}